<template>
    <div></div>
</template>

<script>

    import {getRequest, postRequest, getBase64} from "../base/ApiService";

    export default {
        name: "ApiService",

        uploadNoticeS3(data, callback, error) {
            getBase64(data['file'], function(result){
                data['file'] = result;
                return postRequest('uploadNoticeS3', data).then(callback).catch(error)
            });
        },
        uploadBannerS3(data, callback) {
            getBase64(data['file'], function(result){
                data['file'] = result;
                return postRequest('uploadBannerS3', data).then(callback)
            });
        },
        uploadUserFilesS3(data, callback, error) {
            getBase64(data['file'], function(result){
                data['file'] = result;
                return postRequest('uploadUserFileS3', data).then(callback).catch(error)
            });
        },
        getUnitList() {
            return getRequest('getUnitList')
        },
        getUnit(key) {
            return getRequest('getUnit', {key: key})
        },
        createUnit(data) {
            return postRequest('createUnit', data)
        },
        getAreaList() {
            return getRequest('getAreaList')
        },
        getAreaForProcessList(key) {
            return getRequest('getAreaForProcessList', {key: key})
        },
        getProcessList() {
            return getRequest('getProcessList')
        },
        createArea(data) {
            return postRequest('createArea', data)
        },
        getCourseTypeList() {
            return getRequest('getCourseTypeList')
        },
        getCourseTypeForProcessList(key) {
            return getRequest('getCourseTypeForProcessList', {key: key})
        },
        createCourseType(data) {
            return postRequest('createCourseType', data)
        },
        getCourseList(queryParams) {
            return getRequest('getCourseList', null, queryParams)
        },
        getCourse(key) {
            return getRequest('getCourse', {key: key})
        },
        createCourse(data) {
            return postRequest('createCourse', data)
        },
        getPlaceList() {
            return getRequest('getPlaceList')
        },
        createPlace(data) {
            return postRequest('createPlace', data)
        },
        batchCreatePlace(data) {
            return postRequest('batchCreatePlace', data)
        },
        copySelectionProcess(key) {
            return postRequest('copySelectionProcess', {}, {key: key})
        },
        deleteSelectionProcess(key) {
            return postRequest('deleteSelectionProcess', {}, {key: key})
        },
        pauseSelectionProcess(key) {
            return postRequest('pauseSelectionProcess', {}, {key: key})
        },
        resumeSelectionProcess(key) {
            return postRequest('resumeSelectionProcess', {}, {key: key})
        },
        getSelectionProcess(key) {
            return getRequest('getSelectionProcess', {key: key})
        },
        saveSelectionProcessDraft(data) {
            return postRequest('saveSelectionProcessDraft', data)
        },
        publishSelectionProcess(key, data) {
            return postRequest('publishSelectionProcess', data, {key: key})
        },
        sendProcessEmail(data) {
            return postRequest('sendProcessEmail', data)
        },
        getTotalSubscriptions(key){
            return getRequest('getTotalSubscriptions', {key: key})
        },
        getProcessResult(key){
            return postRequest('getResult', {}, {key: key})
        },
        getProcessResultComplete(key, data){
            let additionalData = {include_all: true};
            return postRequest('getResult', { ...data, ...additionalData }, {key: key})
        },
    }

</script>
